export default {
  "button.add": "Add",
  "button.addTransaction": "Add Transaction",
  "button.delete": "Delete",
  "button.edit": "Edit",
  "button.login": "Login",
  "button.signup": "Signup",
  "category.name": "Name",
  "category.type": "Type",
  "categoryModal.titleModalAdd": "Add Category",
  "categoryModal.titleModalEdit": "Edit Category",
  "date.april": "April",
  "date.august": "August",
  "date.december": "December",
  "date.february": "February",
  "date.friday": "F",
  "date.january": "January",
  "date.july": "July",
  "date.june": "June",
  "date.march": "March",
  "date.may": "May",
  "date.monday": "M",
  "date.november": "November",
  "date.october": "October",
  "date.saturday": "S",
  "date.september": "September",
  "date.sunday": "Su",
  "date.thuesday": "Tu",
  "date.thursday": "Th",
  "date.wednesday": "W",
  "error.incorrectEmail": "Please fill in a correct Email address",
  "error.incorrectPassword": "Please fill in a password",
  "form.fieldEmail": "Email",
  "form.fieldPassword": "Password",
  "form.incomeExpense": "Income/Expense",
  "form.selectMonth": "Select a date",
  "login.linkCreateAccount": "Create account here",
  "login.noAccount": "No account yet?",
  "login.titleLogin": "Login",
  "navigation.categories": "Categories",
  "navigation.overview": "Overview",
  "navigation.logout": "Logout",
  "navigation.transactions": "Transactions",
  "notifications.errorFillInAllFields": "Please fill in all the fields",
  "notifications.errorLogin": "Error with login",
  "notifications.errorLogout": "Something went wrong login you out.",
  "notifications.successLogin": "Login is a success",
  "notifications.successLogout": "Logout is a success",
  "signup.goBackTo": "Go Back to",
  "signup.titleSignup": "Signup",
  "table.expense": "Expense",
  "table.income": "Income",
  "table.noTotalsTracked": "No {0} Tracked",
  "table.totals": "Totals",
  "transaction.amount": "Amount",
  "transaction.category": "Category",
  "transaction.date": "Date",
  "transaction.name": "Name",
  "transactionModal.titleModalAdd": "Add Transaction",
  "transactionModal.titleModalEdit": "Edit Transaction",
  "button.addCategory": "Add Category",
  "navigation.settings": "Settings",
  "form.chooseLanguage": "Choose Language",
  "update.newVersionDetected": "New version detected.",
  "update.reload": "Reload",
  "export.exportCSV": "Export CSV",
  "authentication.loggedIn": "Logged in: ",
};
